import './App.css';
import Main from "./ui/Main";

function App() {
    return <>
        <Main/>
    </>
}

export default App;
